import React, { useRef, useState } from "react";
import { Upload, X, ImageIcon, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { uploadImage, resolveImageUrl } from "@/lib/imageUpload";

export default function ImageUploader({ value, onChange, password, label = "图片", aspectClass = "aspect-square" }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("请上传图片文件");
      return;
    }
    setUploading(true);
    try {
      const res = await uploadImage(file, password);
      onChange(res.url);
      toast.success("图片已上传", { id: "img-up" });
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.detail || "上传失败");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div>
      <div className="text-[10px] tracking-[0.25em] uppercase text-slate-500 font-display mb-2">{label}</div>
      <div className="flex items-center gap-4">
        <div className={`relative ${aspectClass} w-28 bg-slate-100 border border-slate-200 rounded-sm overflow-hidden shrink-0`}>
          {value ? (
            <img src={resolveImageUrl(value)} alt="" className="w-full h-full object-cover" />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-slate-400">
              <ImageIcon size={20} />
            </div>
          )}
          {uploading && (
            <div className="absolute inset-0 bg-white/80 flex items-center justify-center">
              <Loader2 size={20} className="animate-spin text-orange-600" />
            </div>
          )}
        </div>
        <div className="flex flex-col gap-2">
          <button
            type="button"
            onClick={() => inputRef.current?.click()}
            disabled={uploading}
            data-testid={`img-upload-${label}`}
            className="inline-flex items-center gap-2 px-3 py-2 text-xs border border-slate-300 hover:border-orange-600 hover:text-orange-600 rounded-sm transition-colors disabled:opacity-50"
          >
            <Upload size={12} /> 上传新图
          </button>
          {value && (
            <button
              type="button"
              onClick={() => onChange("")}
              className="inline-flex items-center gap-2 px-3 py-2 text-xs text-slate-500 hover:text-red-600 rounded-sm transition-colors"
            >
              <X size={12} /> 移除
            </button>
          )}
        </div>
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          onChange={handleFile}
          className="hidden"
        />
      </div>
    </div>
  );
}
